import React, { useState, useRef, useEffect, useContext } from "react";
import { FormValidate } from '../../common'
import { Input, Icon, } from 'semantic-ui-react'
import { useHistory, NavLink } from "react-router-dom";
import "./Login.scss";
import logo from "../../assets/home/atar_logo.png";
import { StarButton } from '../../components'
import { useSelector, useDispatch } from 'react-redux'
import { otpSend, saveNumber, setIsSignUp, saveReferral } from '../../store/AuthRedux'
import { useTranslation } from "react-i18next";

const Login = () => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const isFetching = useSelector((state) => state.auth.isFetching)
  const isOptSend = useSelector((state) => state.auth.isOptSend)
  const isSignUp = useSelector((state) => state.auth.isSignUp)
  const { t, i18n } = useTranslation();
  const pageActive = useRef(false);
  const nameInput = useRef(null);
  const phoneInput = useRef(null);
  const history = useHistory();
  const [name, setName] = useState('')
  const [errorName, setErrorName] = useState(null)
  const [phone, setPhone] = useState('')
  const [error, setError] = useState(null)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const getOtp = () => {
    if (isSignUp && (!name)) {
      setErrorName('Please enter your name')
      nameInput.current.focus();
      return
    }
    if (isSignUp && (!FormValidate.isName(name))) {
      setErrorName('Please enter a valid name')
      nameInput.current.focus();
      return
    }
    if (!FormValidate.isPhone(phone)) {
      setError('Please enter your phone number')
      phoneInput.current.focus();
      return
    }
    let params = { name, phone }
    pageActive.current = true;
    dispatch(saveReferral(name ? true : false))
    dispatch(saveNumber(phone))
    dispatch(otpSend(params))
  }

  useEffect(() => {
    if (token) {
      history.push("/");
    }
  }, [token]);

  useEffect(() => {
    if (isOptSend && pageActive.current) {
      history.push("/otp");
    }
  }, [isOptSend]);

  useEffect(() => {
    setName('')
  }, [isSignUp]);


  return (
    <>
      <div className="container-fluid home clearall">
        <div className="bg">
          <div className="img_sec">
            <div className="singup_sec">
              <div className="singup">
                <NavLink
                  to="">
                  <img className="login_logo" src={logo} />
                </NavLink>
                <div className="dream_sec">
                  <div className="innerdream_sec">
                    {errorName ? <div className="login_error">{errorName}</div> : ''}
                    {error ? <div className="login_error">{error}</div> : ''}
                    <h3>{t("login.titel")}</h3>
                    <div className="account_sec">
                      <div className="already">{isSignUp ? t("login.para") : t("signs.para")} <span onClick={() => dispatch(setIsSignUp(!isSignUp))}><a>{isSignUp ? t("login.sign") : t("login.signs")}</a> </span></div>
                      <h5><a>{!isSignUp ? t("login.sign") : t("login.signs")}</a></h5>
                    </div>

                    {isSignUp && (<div className="input-group mb-3">
                      <Input fluid className={"fast_input " + (errorName ? "inputError" : '')} iconPosition='left'>
                        <Icon className="user_icon" name='user' />
                        <input
                          ref={nameInput}
                          placeholder='Enter your name'
                          type="text"
                          value={name}
                          onChange={(obj) => {
                            setName((obj.target.value).trimStart());
                            setErrorName(null)
                          }}
                        />
                      </Input>
                    </div>)}

                    <div className="input-group mb-3">
                      <Input fluid label='+91' className={"fast_input " + (error ? 'error' : '')}
                        placeholder='Enter mobile number'
                        ref={phoneInput}
                        type="number"
                        value={phone}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.') && evt.preventDefault()}
                        onChange={(obj) => {
                          if (obj.target.value.length === 11) return false;
                          setPhone(obj.target.value);
                          setError(null)
                        }}
                      />

                    </div>
                    <div className="account_sec">
                      <div className="already">{t("login.agree")} <span><a onClick={() => history.push("/termsconditions")}>{t("login.already")}</a></span> {t("login.agre")} <span><a onClick={() => history.push("/privacypolicy")}> {t("login.privacy")}</a></span>{t("login.policy")}</div>
                    </div>
                    <div style={{ marginTop: "29px", position: "relative" }}>
                      <StarButton background={'mainBg'} width="100%" isLoading={isFetching} title={t("login.btn")} onClickAction={() => getOtp()} disableStar={phone.length > 9 ? false : true} isGray={phone.length > 9 ? false : true} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login